import { useAuthAndPrivilege } from './useAuthAndPrivilege';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from '../components/admincomponents/components/Loading';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { useEffect, useState } from 'react';
import { useRehydrateAuth } from './useRehydrateAuth';

interface ProtectedProps {
  requiredPrivilege?: string | null | undefined;
}
const ProtectedRoute = ({ requiredPrivilege }) => {
  // Rehydrate if it is necessary. This means public api will not need rehydrate
  useRehydrateAuth();
  const { isRehydrating } = useSelector(
    (state: RootState) => state.userPrivileges
  );
  const { isAuthenticated, hasRequiredPrivilege } =
    useAuthAndPrivilege(requiredPrivilege);
  const [loadingMessage, setLoadingMessage] = useState('Loading...');
  const [forceRedirect, setForceRedirect] = useState(false);

  useEffect(() => {
    if (!isRehydrating) return;

    // Fallback timeout: force redirect after 12 seconds
    const fallbackTimer = setTimeout(() => {
      setForceRedirect(true);
    }, 12000);

    // Update message after 8 seconds
    const messageTimer = setTimeout(() => {
      setLoadingMessage('Session expired, redirecting to login...');
    }, 8000);

    return () => {
      clearTimeout(fallbackTimer);
      clearTimeout(messageTimer);
    };
  }, [isRehydrating]);

  // Force redirect if timeout exceeded
  if (forceRedirect) {
    return <Navigate to="/login" replace />;
  }

  // Wait for rehydration to complete
  if (isRehydrating) {
    return <Loading message={loadingMessage} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // 2. Check Authorization (Privilege)
  if (!hasRequiredPrivilege) {
    // Redirect to an unauthorized access page if logged in but permissions are missing.
    return <Navigate to="/unauthorized" replace />;
  }

  // if both check pass, render the child component/route
  return <Outlet />;
};
export default ProtectedRoute;
